export function matchesContentId(contentId: string, contentIdToMatch: string) {
  return [contentIdToMatch, `fr-${contentIdToMatch}`].includes(contentId);
}
